import React from 'react';
import { TextField } from 'src/components/ui/TextField';

const ParagraphClientForm = (props) => (
    <TextField
        {...props}
        variant="textarea"
        rows={4}
    />
);

export default ParagraphClientForm;
